import { useRef } from 'react'
import {
  Button,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'

// Read-only/editable sibling of the offer feature's DocumentDetailModal, kept
// free of Redux/react-hook-form/offer-specific APIs so it can be shared by
// client and client_external, which don't share data-fetching hooks.
const CategoryFileListModal = ({
  isOpen,
  onClose,
  title,
  files = [],
  editable = false,
  onView,
  onDownload,
  onRemoveFile,
  onAddFiles,
  allowedFileTypes,
}) => {
  const fileInputRef = useRef(null)

  const handleFileInputChange = (e) => {
    if (e.target.files?.length > 0 && onAddFiles) {
      onAddFiles(e.target.files)
    }
    e.target.value = ''
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent maxW="900px">
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Table>
            <Thead>
              <Tr>
                <Th>File Name</Th>
                <Th></Th>
              </Tr>
            </Thead>
            <Tbody>
              {files.map((file) => (
                <Tr key={file._id}>
                  <Td>{file.originalFileName}</Td>
                  <Td>
                    <HStack justifyContent="flex-end">
                      <Button type="button" colorScheme="blue" size="sm" onClick={() => onView?.(file)}>
                        View
                      </Button>
                      <Button type="button" colorScheme="green" size="sm" onClick={() => onDownload?.(file)}>
                        Download
                      </Button>
                      {editable && (
                        <Button type="button" colorScheme="red" size="sm" onClick={() => onRemoveFile?.(file)}>
                          Remove
                        </Button>
                      )}
                    </HStack>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          {editable && (
            <Input
              ref={fileInputRef}
              type="file"
              accept={allowedFileTypes}
              multiple
              onChange={handleFileInputChange}
              maxW="320px"
            />
          )}
          <Spacer />
          <Button type="button" colorScheme="gray" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default CategoryFileListModal
